import { calculateTimeDurationInMinutes } from './calculateTimeDurationInMinutes';
import { AssignmentFormValue } from './MultiAssignmentManagementFormStep2/FormValues';

export type AssignmentDaysToAssignmentFormValueMap = Record<
  string,
  AssignmentFormValue
>;

export function makeAssignedDays(
  assignments: AssignmentDaysToAssignmentFormValueMap
) {
  return Object.keys(assignments)
    .filter((dayKey) => {
      return assignments[dayKey].isEditing;
    })
    .map((dayKey) => {
      const assignmentForDay = assignments[dayKey];
      return {
        day: dayKey,
        start: assignmentForDay.start,
        duration_minutes: calculateTimeDurationInMinutes(
          assignmentForDay.start,
          assignmentForDay.end
        ),
      };
    })
    .filter((t) => t.duration_minutes > 0);
}
